import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PublicHome from './components/PublicHome';
import PublicThread from './components/PublicThread';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import AdminArchieve from './components/AdminArchieve';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        {/* <Route path="/" element={<PublicHome />} />
        <Route path="/thread/:referenceID" element={<PublicThread />} /> */}

        {/* Admin Routes */}
        <Route path="/" element={<AdminLogin />} />
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/archive" element={<AdminArchieve />} />

      </Routes>
    </Router>
  );
}

export default App;